var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect, useState } from 'react';
import { FIELD_NAMES, STATUS_VALUES, VISIBILITY_VALUES } from '../types';
export var useEditListFormState = function (initialValues, isValueLoading) {
    var _a;
    var _b = useState((_a = {},
        _a[FIELD_NAMES.LIST_NAME] = initialValues === null || initialValues === void 0 ? void 0 : initialValues.name,
        _a[FIELD_NAMES.DESCRIPTION] = initialValues === null || initialValues === void 0 ? void 0 : initialValues.description,
        _a[FIELD_NAMES.STATUS] = (initialValues === null || initialValues === void 0 ? void 0 : initialValues.isActive) ? STATUS_VALUES.ACTIVE : STATUS_VALUES.INACTIVE,
        _a[FIELD_NAMES.VISIBILITY] = (initialValues === null || initialValues === void 0 ? void 0 : initialValues.isPrivate) ? VISIBILITY_VALUES.PRIVATE : VISIBILITY_VALUES.SHARED,
        _a)), listOriginalState = _b[0], setListOriginalState = _b[1];
    var _c = useState(listOriginalState), state = _c[0], setState = _c[1];
    var onValueChange = useCallback(function (value) {
        setState(function (prevState) {
            return __assign(__assign({}, prevState), value);
        });
    }, []);
    useEffect(function () {
        var _a;
        if (!isValueLoading && initialValues) {
            var listObject_1 = (_a = {},
                _a[FIELD_NAMES.LIST_NAME] = initialValues.name,
                _a[FIELD_NAMES.DESCRIPTION] = initialValues.description,
                _a[FIELD_NAMES.STATUS] = initialValues.isActive ? STATUS_VALUES.ACTIVE : STATUS_VALUES.INACTIVE,
                _a[FIELD_NAMES.VISIBILITY] = initialValues.isPrivate ? VISIBILITY_VALUES.PRIVATE : VISIBILITY_VALUES.SHARED,
                _a);
            setState(function () { return listObject_1; });
            setListOriginalState(function () { return listObject_1; });
        }
    }, [initialValues, isValueLoading]);
    var hasDirtyFields = !isValueLoading && JSON.stringify(listOriginalState) !== JSON.stringify(state);
    var isListBecameActive = listOriginalState[FIELD_NAMES.STATUS] === STATUS_VALUES.INACTIVE
        &&
            state[FIELD_NAMES.STATUS] === STATUS_VALUES.ACTIVE;
    return {
        state: state,
        onValueChange: onValueChange,
        hasChanges: hasDirtyFields,
        isListBecameActive: isListBecameActive
    };
};
